import React, { Fragment } from "react";
import { withGetScreen } from "react-getscreen";
import Card from "../../../shared/Card/Card";

const SmartExtractHeader = props => {
	return props.isMobile() ? (
		<Card>
			<h1 className="offers-smart-extract__title">EXTRATO INTELIGENTE</h1>
			<p className="offers-smart-extract__subtitle">
				Lorem ipsum dolor sit amet, consectetur adipiscing elit:
			</p>
		</Card>
	) : (
		<Fragment>
			<h1 className="offers-smart-extract__title">EXTRATO INTELIGENTE</h1>
			<p className="offers-smart-extract__subtitle">
				Lorem ipsum dolor sit amet, consectetur adipiscing elit:
			</p>
		</Fragment>
	);
};

export default withGetScreen(SmartExtractHeader, {
	mobileLimit: 468, // TODO Fix screen vars
	tabletLimit: 768, // TODO Fix screen vars
	shouldListenOnResize: true
});
